export default {
  signInNotRegistered: "Ройхатдан ўтмаганмисиз ?",
  signInRegister: "Ройхатдан ўтиш",
  message: "O'zbek",

  logout: "Чиқиш",
  LoginPersonalAcc: "Shaxsiy profilga kirish",
  getCode: "Kodni qabul qilish",
  Enter: "Kirish",
  verficationCode: "Tasdiqlash kodi",
  online_kassa: "Sotuv",

  reports: "Хисоботлар",
  sales_summary: "Умумий хисоботлар",
  abc_analysis: "ABC-анализ",
  sales_by_item: "Товарлар бўйича",
  sales_by_category: "Категория бўйича",
  sales_by_employee: "Ишчилар бўйича",
  sales_by_payment: "Тўловлар бўйича",
  receipts: "Чеклар",
  debts: "Қарзлар",
  discounts: "Чегирмалар",
  taxes: "Солиқлар",
  shifts: "Касса хисоботи",

  items: "Товарлар",
  item_list: "Товарлар рўйхати",
  categories: "Категориялар",
  modifiers: "Модификатор",

  inventory_management: "Инвентаризация бошқаруви",
  purchase_orders: "Фирмага буюртма",
  transfer_orders: "Товарни узатиш",
  stock_adjusment: "Қолдиқларни тузатиш",
  inventory_counts: "Инвентаризация",
  productions: "Ишлаб чиқариш",
  suppliers: "Фирмалар",
  inventory_history: "Товарлар тарихи",
  inventory_valuation: "Қолдиқ",

  employees: "Ходимлар",
  employee_list: "Ходимлар рўйхати",
  access_rights: "Кириш ҳуқуқи",
  timecards: "Смена",
  total_hours_worked: "Жами ишлаган вақти",

  customers: "Харидорлар",

  settings: "Созламалар",
  general: "Умумий",
  payment_types: "Тўлов усули",
  loyalty: "Бонус",
  open_tickets: "Очиқ чеклар",
  kitchen_printers: "Ошхона принтерлари",
  stores: "Филиаллар",
  pos_devices: "Касса",

  all_day: "Кун давомида",
  custom: "Календарь",
  start: "Боши",
  end: "Охири",
  all_stores: "Барча филиаллар",
  all_employees: "Барча ишчилар",
  all_reasons: "Барча сабаблар",
  gross_sales: "Барча сотувлар",
  refunds: "Қайтарилган товарлар",
  net_sales: "Тушум",
  gross_profit: "Ялпи фойда",
  date: "Сана",
  cost_of_goods: "Таннархи",

  item_name: "Товар номи",
  items_sold: "Сотилган товарлар",
  gross_profit_analysis: "Ялпи фойда таҳлили",
  net_sales_analysis: "Тушум таҳлили",
  gross_sales_analysis: "Ялпи сотиш таҳлили",

  item: "Товар",
  sku: "SKU",
  category: "Категория",
  items_refunded: "Қайтарилган маҳсулот",

  average_sale: "Ўртача сотув",

  payment_type: "Тўлов усули",
  payment_transactions: "Тўлов операциялари",
  payment_amount: "Тўлов суммаси",
  refund_transactions: "Қайтарилган товарлар операциялари",
  refund_amount: "Қайтарилган товарлар миқдори",
  net_amount: "Соф миқдор",

  all: "Ҳаммаси",
  sales: "Сотувлар",
  sold: "Сотилган",
  receipt_no: "Чек рақамлари",
  store: "Филиал",
  employee: "Ишчи",
  customer: "Харидор",
  type: "Тури",
  total: "Жами",
  cashier: "Кассир",
  pos: "Касса",

  donator: "Donator",
  accepted_time: "Қабул қилинган вақт",
  receiver: "Қабул қилувчи",
  receive: "Қабул қилиш",
  charged: "Charged",

  name: "Номи",
  discount_applied: "Чегирма қўлланмаси",
  amount_applied: "Қўлланиладиган миқдор",

  taxable_sales: "Солиқ солинадиган савдо",
  non_taxable_sales: "Солиқ солинмайдиган савдо",
  total_net_sales: "Жами соф савдо",
  tax_name: "Солиқ номи",
  tax_amount: "Солиқ суммаси",

  opening_time: "Очилиш вақти",
  closing_time: "Ёпилиш вақти",
  exp_cash_amount: "Кутилаётган пул миқдори",
  act_cash_amount: "Нақд пулнинг миқдори",
  difference: "Фарқи",
  shift_report: "Ўзгариш хисоботи",
  shift_opened: "Ўзгариш очилиши",
  shift_closed: "Ўзгариш ёпилиши",
  cash_drawer: "Cash drawer",
  starting_cash: "Бошланғич нақд пул",
  cash_payments: "Пул тўловлари",
  cash_refunds: "Нақд пул қайтармалари",
  paid_in: "Йиллик тўлов",
  paid_out: "Paid out",

  add_item: "Товар қўшиш",
  import: "Импорт",
  export: "Эскпорт",
  upload: "Upload",
  print_labels: "Этикеткани босиб чиқариш",
  stock_alert: "Қолдиқ",
  create_item: "Товар яратиш",
  update_item: "Update item",
  sold_by: "Ким томонидан сотилган",
  each: "Донага",
  weight: "Вазнига",
  price: "Нархи",
  cost: "Қиймати",
  barcode: "Штрихкод",
  inventory: "Балансларни ҳисобга олиш",
  composite_item: "Товар композицияси",
  track_stock: "Мовозанятны сакланг",
  use_production: "Ишлаб чиқаришдан фойдаланиш",
  quantity: "Миқдори",
  you_have_not_selected_items_yet: "Сиз ҳали товарарни танламадингиз",
  available: "Мавжуд",
  primary_supplier: "Асосий йетказиб берувчи",
  default_purchase_cost: "Стандарт сотиб олиш қиймати",
  in_stock: "Запасда",
  all_items: "Барчаси",
  low_stock: "Кам миқдордаги запас",
  out_of_stock: "Стокда йўқ",
  optimal_stock: "Оптимал миқдорли запас",
  representation: "Товарлар кўрсатилиши",
  color_and_shape: "Ранг ва шакли",
  square: "Тўртбурчак",
  circle: "Доира",
  octagonal: "Саккизбурчак",
  hexagon: "Олтибурчак",
  cancel: "Бекор қилиш",
  create: "Яратиш",
  label_type: "Этикетка тури",
  barcode_source_field: "Штрихкод манбааси",
  print_name: "Номни киритиш",
  print_price: "Нархни киритиш",
  add_by_category: "Категория бўйича қўшиш",
  add_by_supplier: "Йетқазиб берувчи фирмалар бўйича қўшиш",
  please_add_at_least_one_item: "Илтимос, камида битта элемент қўшинг",
  print: "Print",
  create_labels: "Этикетка яратиш",

  add_category: "Категория қўшиш",
  delete: "Ўчириш",
  create_category: "Категоврия яратиш",
  category_name: "Категория номи",
  update: "Янгилаш",

  add_modifier: "Модификатор қўшиш",
  modifier: "Модификатор",
  modifier_name: "Модификатор номи",
  option_name: "Вариант номи",
  add_option: "Вариант кўшиш",
  save: "Сақлаш",

  add_discount: "Чегирма қўшиш",
  value: "Қиймати",
  percentage: "Фоиз",
  amount: "Миқдори",

  add_purchase: "Буюртма қўшиш",
  status: "Ҳолати",
  supplier: "Йетқазиб берувчи",
  purchase_order: "Фирмага буюртма",
  received: "Қабул қилинди",
  exp_on: "Кутилаётган йетқазиб бериш санаси",
  tin: "JSHSHIR",

  create_purchase: "Сотиб олишни яратиш",
  purchase_order_date: "Буюртма санаси",
  expected_on: "Кутилаётган йетқазиб бериш санаси",
  note: "Қайдлар",
  incoming: "Кутилмоқда",
  purchase_cost: "Сотиб олиш нархи",
  add_additional_cost: "Қўшимча харажатлар қўшиш",
  additional_cost: "Қўшимча харажатлар қўшиш",
  ordered_by: "Заказига биноан",
  destination_store: "Филиалнинг мақсади",
  closed: "Ёпилган",
  pending: "Кўрилмоқда",
  returned_order: "Қайтарилган заказлар",
  partially: "Қисман",
  notes: "Қайдлар",

  add_transfer: "Харатланишни қўшиш",
  transfer_order: "Харакатланиш",
  source_store: "Жўнатувчи",
  create_transfer: "Характланишни яратиш",
  date_of_tranfer_order: "Харакатланиш санаси",
  source_stock: "Жўнатувчининг баланси",
  destination_stock: "Қабул қилувчининг баланси",
  in_transit: "Транзитда",
  transferred: "Узатилди",
  edit: "ўзгартириш",
  more: "кўпроқ",
  canceled: "бекор килинган",

  add_stock_adjustment: "Қолдиқ товарларни созлаш",
  reason: "Сабаб",
  receive_items: "Товарни олиш",
  returned_back: "Орқага қайтди",
  returned: "Қайтган",
  recounted: "Қайта саналган",
  inventory_count: "Инвентаризация сони",
  recount: "Инвентаризация сони",
  loss: "Йўқотиш",
  lost: "Йўқотилган",
  "item edit": "Тахрирланди",
  damage: "Зарар олган маҳсулот",
  damaged: "Загарланган",
  create_stock_adjustment: "Созлашни яратиш",
  add_stock: "Қабул қилинди",
  stock_after: "Кейинги қолдиқ",
  all_stock_adjustment: "Балансдаги барча созланишлар",
  adjusted_by: "Томонидан созланяпти",
  expected_stock: "Кутилаётган қолдиқ",
  counted_stock: "Ҳисобланган қолдиқ",
  remove_stock: "Remove stock",

  add_inventory_count: "Инвентаризация қўшиш",
  in_progress: "Процессда",
  completed: "Якунланган",
  date_created: "Яратилган сана",
  date_completed: "Якунланган сана",
  create_inventory_count: "Инвентаризация сонини яратиш",
  partial: "Қисман",
  full: "Тўлиқ",
  created_by: "Томонидан яратилган",
  counted: "Саналган",
  cost_difference: "Харажатлар фарқи",
  count_stock: "Инвентаризация",

  add_production: "Ишлаб чиқаришни кўшиш",
  production: "Ишлаб чиқариш",
  disassembly: "Disassembly",
  create_production: "Ишлаб чиқаришни яратиш",

  add_supplier: "Йетқазиб берувчини қўшиш",
  contact: "Алоқа учен шаҳс",
  phone_number: "Телефон",
  email: "Email",
  create_supplier: "Йетқазиб берувчини яратиш",
  supplier_name: "Йетқазиб берувчининг исми",
  website: "Веб-сайт",
  address_1: "Адрес 1",
  address: "Адрес",
  address_2: "Адрес 2",
  city: "Шахар",
  postal_zip_code: "Почта индекси",
  country: "Мамлакат",
  region_state_province: "Вилоят/Давлат/Туман",

  adjustment: "Созлаш",

  total_inventory_value: "Инвентаризациянинг умумий қиймати",
  total_retail_value: "Жами оптом қиймати",
  potential_profit: "Потенциал фойда",
  margin: "Маржа",
  inventory_value: "Инвентаризация қиймати",
  retail_value: "Оптом қиймат",

  add_employee: "Ишчи қўшиш",
  role: "Ўрни",
  password: "Password",

  add_role: "Ўрин қўшиш",
  access: "Кириш ҳуқуқи",
  employees_can_log_in_to_the_app_using_personal_PIN_code:
    "Ходимлар ўз ПИН-кодидан фойдаланган қолда иловага киришлари мумкин",
  close_ticket: "Чекни ёпиш",
  print_pre_check: "Чоп этишдан олдин текшириш",
  refund: "Қайтаридан пул",
  show_all_receipts: "Барча тушумларни кўрсатиш",
  pay_debt: "Қарзни тўлаш",
  show_shift_history: "Смена тарихини кўрсатиш",
  apply_discount: "Чегирмани қўллаш",
  change_settings: "Созламаларни ўзгартириш",
  show_stock: "Show stock",
  edit_items: "Товарларни ўзгартириш",
  edit_ticket: "Чекни ўзгартириш",
  split_check: "Алоҳида чек",
  change_waiter: "Официантни алмаштириш",
  change_ticket: "Чекни алмаштириш",
  delete_ticket: "Чекни ўчириш",
  show_all_tickets: "Барча чекларни кўрсатиш",
  back_office: "Back office",
  employees_can_log_in_to_the_back_office_using_their_email_and_password:
    "Ходимлар электрон почта манзили ва паролидан фойдаланиб, веб-ҳисобга киришлари мумкин",
  edit_profile: "Профильни ўзгартириш",
  set_the_taxes: "Солиқларни белгилаш",
  manage_pos_devices: "Рos-тизимларини бошқариш",
  can_delete_item: "Can delete item",

  add_timecard: "Иш вақтини ҳисобга олиш варақасини қўшиш",
  clock_in: "Бошлаш вақти",
  clock_out: "Якунлаш вақти",
  total_hours: "Ишланган соатлар",
  clock_in_date: "Бошланиш санаси",
  clock_out_date: "Якунлаг санаси",
  clock_in_time: "Чиқиш вақти",
  clock_out_time: "Кириш вақти",

  add_customer: "Харидор қўшиш",
  contacts: "Контактлар",
  first_visit: "Дастлабки ташриф",
  last_visit: "Сўнгги ташриф",
  total_visits: "Умумий ташрифлар",
  total_spent: "Умумий  харидлар миқдори",
  points_balance: "Баллар баланси",
  first_name: "Исм",
  last_name: "Фамилия",

  general_settings: "Умумий созламалар",
  bussiness_name: "Филиал номи",
  UI_language: "Интерфейс тили",
  features: "Хусусиятлари",
  track_cash_that_goes_in_and_out_of_your_drawer:
    "Кассадаги нақд пул ҳисобини олиб бориш.",
  time_clock: "Ходимларнинг иш вақтини кузатиш",
  track_employees_clock_in_out_time_and_calculate_their_total_work_hours: `Ходимларнинг иш бошланиш ва тугатиш вақтини ёзиб боринг ва ҳисобланг.`,
  allow_to_save_and_edit_orders_before_completing_a_payment:
    "Тўловни бажаришдан олдин буюртмаларни сақлаш ва таҳрирлашга рухсат беринг.",
  show_my_debts: "Менинг қарзларимни кўрсатиш",
  open_receipts: "Очиқ квитанциялар",
  save_receipt_as_unpaid: "Квитанцияни тўланмаган сифатида сақлаш",
  orders: "Заказлар",
  show_customer_order_section_and_and_get_orders:
    "Харидорнинг буюртма қилган қисмини кўрсатиш ва буюртма олиш",
  chat: "Чат",
  show_support_chat_section: "Чат поддержка бўлимини кўрсатиш",
  karaoke: "Караоке",
  can_sell_karaoke_type_item: "Караоке усулини бекор қилиш",
  scale: "Масштаб",
  connect_to_scale_for_markets: "Connect to scale for markets",
  section: "Секциялар",
  enable_the_bar_printers: "Enable the bar printers",
  inventery_menegment: "Инвентаризацияни бошқариш",
  local_server: "Маҳаллий сервер",
  share_tickets_in_a_local_area_call_us_before_turn_it_on:
    "Share tickets in a local area, call us before turn it on!",
  cash: "Кеш",
  card: "Карта",
  gift: "Совға",
  debt: "Қарз",
  qr_code: "QR Code",
  nfc: "NFC",
  online_payment: "Онлайн тўловлар",
  transfer_pay: "Перчисления",
  loyalty_settings: "Бонус созламалари",
  loyalty_type: "Бонус услуби",
  bonus_system: "Бонус системаси",
  a_percentage_of_the_purchase_amount:
    "Мижознинг баллар ҳисобидан яратиладиган харид суммасининг фоизи",

  add_tax: "Солиқ қўшиш",
  tax_rate: "Солиқ ставкаси, %",
  options: "Вариантлар",

  add_predefined_ticket: "Олдиндан белгиланган квитансияни қўшиш",

  add_printer_group: "Add printer group",
  count: "Ҳисоблаш",

  add_store: "Филиал қўшиш",
  number_of_pos: "POS-тизими миқдори",
  description: "Tavsifnoma",

  add_pos: "POS-тизимини қўшиш",

  workgroup: "Workgroup",
  add_workgroup: "Add workgroup",
  create_employee: "Create Employee",

  variant: "Variant",
  sales_by_modifier: "Sales by modifier",

  this_field_can_not_be_blank: "Это поле не может быть пустым",
  wrong_phone: "Wrong phone",

  update_customer: "Update Customer",
  create_customer: "Create Customer",

  rest_debt: "Rest debt",
  paid: "Paid",

  supplier_transaction: "Supplier Transaction",
  balance: "Balance",
  document: "Document",
  uzs: "UZS",
  usd: "USD",
  all_suppliers: "All Suppliers",
  coming: "Coming",
  report_account: "Report Account",
  all_cash: "All Cash",
  all_card: "All Card",
  consumption: "Consumption",
  fees: "Fees",
  one_time_fees: "One time fees",
  salary: "Salary",
  company_to_fees: "Company to fees",
  create_fee: "Create fee",
  add_fee: "Add fee",
  comment: "Comment",
  amount_type: "Amount type",
  balance_type: "Balance type",
  currency: "Currency",
  buttons: "Buttons",
  pay_in: "Pay in",
  pay_out: "Pay out",
  none: "None",
  create_task: "Create task",
  client: "Client",
  wharehouse_manager: "Wharehouse manager",
  edit_sold_item: "Edit sold item",
  all_categories: "All categories",
  stock: "Stock",
  fee: "Fee",
  created_at: "Created at",
  order_number: "Order number",
  workgroup_orders_report: "Workgroup orders report",
  total_actual_cost_sum: "Total actual cost",
  total_production_cost_sum: "Total production cost",
  can_access_to_shift: "Can access to shift",
  add_receipt: "Add receipt",
  create_receipt: "Create receipt",
  option: "Option",
  transfer: "Transfer",
  reports_safe: "Reports safe",
  by_user: "By user",
  uzs_value: "Uzs value",
  usd_value: "Usd value",
  transfer_value: "Transfer value",
  customer_debt: "Customer debt",
  no_rounding: "Не округлять",
  rounding_to_50_summ: "Округлять на 50 сум",
  rounding_to_500_summ: "Округлять на 500 сум",
  tech_map: "Tech map",
  add_tech_map: "Add tech map",
  tech_map_detail: "Tech map detail",
  quality: "Quality",
  tech_map_item: "Tech map item",
  by_tech_map: "By tech map",
  show_all: "Show all",
  allready_exist: "Allready exist",
  add_to_stock: "Add to stock",
  active: "Faol",
  inactive: "No faol",
  all_statuses: "All statuses",

  total_minutes: "Jami ishlagan minut",
  total_work_time: "Jami ishlangan vaqt",

  transaction_documents: "Transaction documents",
  create_document: "Create document",
  report_by_items: "Report by items",
  adjust: "Adjust",
  total_spend: "Total spend",
  total_receive: "Total receive",
  total_favor: "Total favor",

  credit: "Credit",

  price_for_pieces: "Price for pieces",
  workgroup_orders_report_by_employee: "Workgroup report by employee",
  employee_name: "Employee name",
  workgroup_name: "Workgroup name",
  enter_receipt_letter: "Enter Receipt letter",
  receipt_letter: "Receipt letter",
  refund_receipt: "Refund receipt",
  service_name: "Service name",
  client_name: "Client name",
  reset_count: "Reset count",
  last_priced_goods: "Narxi o'zgargan tovarlar",
  item_for_mettletoledo: "Mettler toledo SPCT2",
  item_for_mettletoledo_spct1: "Mettler toledo SPCT1",
  item_for_cas_turkish: "Cas Turkish ",
  error_404_sorry: "Кечирасиз, ушбу саҳифага кириш учун сизда рухсат йўқ!",
  export_item_excel: "Export item excel",
  partition_item: "Partition item",
  all_amount: "All amount",
  item_mark_edit: "Item mark edit",
  beta: "BETA",
  create_mark: "Create mark",
  nds: "nds",
  sales_by_supplier: "sales_by_supplier",
  mxik_search: "mxik_search",
  add_from_warehause: "add_from_warehause",
  item_price_change_history: "item_price_change_history",
  organization: "organization",
  client_debt_by_category: "client_debt_by_category",
  use_purchase_cost_on_pricing: "use_purchase_cost_on_pricing",
  receipt: "receipt",
  partition_valuation: "partition_valuation",
  supplier_valuation: "supplier_valuation",
  purchase_mark: "purchase_mark",
  mxik: "mxik",
  epos_token: "epos_token",
  organizations: "organizations",
  organization_name: "organization_name",
  inn: "inn",
  loyalty_bonus: "loyalty_bonus",
  prices: "prices",
  multi_prices: "multi_prices",
  add_items_from_warehause_quickly: "add_items_from_warehause_quickly",
  delivery: "delivery",
  nds_settings: "nds_settings",
  a_percentage_of_the_nds: "a_percentage_of_the_nds",
  receipt_settings: "receipt_settings",
  emailed_receipt: "emailed_receipt",
  add_button: "add_button",
  shop: "shop",
  restaurant: "restaurant",
  market: "market",
  show_customer_info: "show_customer_info",
  header: "header",
  footer: "footer",
  logo: "logo",
  printed_receipt: "printed_receipt",
  show_comments: "show_comments",
  zero: "zero",
  not_zero: "not_zero",
  quantity_left: "quantity_left",
  all_types: "all_types",
  to: "to",
  telegram_acces: "telegram_acces",
  last_date_pricing: "last_date_pricing",
  add_mark: "add_mark",
  old_price: "old_price",
  new_price: "new_price",
  auto_fill: "auto_fill",
  confirm: "confirm",
  litre: "litre",
  creating_item: "creating_item",
  box: "box",
  updating_item: "updating_item",
  add_new: "add_new",
  search: "search",
  no_item_found: "no_item_found",
  create_items: "create_items",
  pcs: "pcs",
  metre: "metre",
  pricing: "pricing",
  reminder: "reminder",
  equal_to_zero: "equal_to_zero",
  positive: "positive",
  group_name_uz: "group_name_uz",
  class_name_uz: "class_name_uz",
  position_uz: "position_uz",
  sub_position_uz: "sub_position_uz",
  unit: "unit",
  brand: "brand",
  attribute_uz: "attribute_uz",
  unit_of_pack: "unit_of_pack",
  draft: "draft",
  set_client: "set_client",
  cash_backs: "Жамғарма",
  real_stock: "real stock",
  accept_by: "Accepted by",
  accept: "Accepted",
  purchase_employee: "purchase employee",
  hot_key: "hot key",
  discount: "Discount",
  nds_value: "nds value",
  dimentions: "dimentions",
  series: "series",
  show_on_bot: "show on bot",
  reciepts_count: "reciepts count",
  average_reciept: "Average reciept",
  customer_detail: "Customer detail",
  total_cost: "Total cost",
  pay_customer_debt: "Pay customer debt",
  user_type: "Mijoz turi",
  natural_user: "Jismoniy shaxs",
  legal_user: "Yuridik shaxs",
  to_time: "To time",
  debt_history: "Debt history",
  from_time: "From time",
  user_id: "User id",
  total_debt: "Total debt",
  get_back: "Get back",
  product_name: "Product name",
  currency_value: "currency value",
  by_name: "by name",
  past_debt: "Past debt",
  paid_debt: "Paid debt",
  director_name: "Director name",
  accaunter: "Accaunter",
  taxes_pair_code: "Taxes pair code",
  org_phone_number: "Organization phone number",
  import_items_excel: "Import items excel",
  promotions_and_discounts: "Promotions and discounts",
  download: "Yuklab olish",
  marking: "Marking",
  is_refund: "Is refund",
  client_status: "Client status",
  add_status: "Add status",
  club_card: "Club card",
  new_item_create: "New item create",
  material_report: "Material report",
  partiation_no: "Partiation no",
  qty_box: "QTY box",
  sale_report: "Sale report",
  partition: "Partition №",
  import_by_barcode: "Import by barcode",
  cashback_out: "Нақт пул",
  birthday: "Tug`ilgan sanasi",
  gender: "Jinsi",
  male: "Erkak",
  female: "Ayol",
  packages: "Paketlar",
  working_days: "Ish kunlari",

  supplier_contract: "Shartnoma №",

  checkedProductsCount: "Tekshirilgan mahsulotlar soni",
  syncProductsCount: "Yangilangan mahsulotlar soni",
  syncNotStarted: "Yangilash hali boshlanmagan. Boshlash uchun \"yangilash\" ni bosing",
  sync: "yangilash",
  startedAt: "Boshlangan vaqt",
  endedAt: "Tugagan vaqt",
};
